import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThirdPartyScriptsService {

  loadDynatrace(url: string): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }
}
